import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';

import {ColorsModel} from '@intocare/ui';

import {CallSignalStatistics} from '../../entities/call-signal.statistics';

@Component({
	selector: 'ic-call-signal-statistics',
	templateUrl: './call-signal-statistics.component.html',
	styleUrls: ['./call-signal-statistics.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CallSignalStatisticsComponent {
	private colors = inject(ColorsModel);

	@Input() statistics: CallSignalStatistics;

	get open() {
		return this.statistics.callevents_created - this.statistics.callevents_closed;
	}

	get end() {
		return (
			Math.ceil(
				Math.max(this.statistics.callevents_average_canceltime, this.statistics.callevents_average_closetime) / 900
			) * 900
		);
	}

	get intervals() {
		return [
			{
				step: 600,
				color: this.colors.getAccent().normal
			},
			{
				step: 900,
				color: this.colors.getOrange().normal
			},
			{
				step: this.end,
				color: this.colors.getRed().normal
			}
		];
	}
}
